// React Core Imports
import { Link } from 'react-router-dom'

// Components & Data Imports
import newsData from '../resources/newsData.json'

// Icons
import { FaAnglesDown } from 'react-icons/fa6'
import { IoCalendar } from 'react-icons/io5'
import { HiLocationMarker } from 'react-icons/hi'
import { GiMoneyStack } from 'react-icons/gi'
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiMailSend,
  BiSolidPhoneCall,
} from 'react-icons/bi'

// Destructuring date from JSON
function parseCzDate(dateStr) {
  const m = dateStr.match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/)
  if (!m) return { day: '', month: '', year: '' }
  return { day: m[1], month: m[2], year: m[3] }
}

const Header = () => {
  // Fetch latest news
  const latest = Array.isArray(newsData) && newsData.length ? newsData[0] : null

  const { day, month, year } = latest
    ? parseCzDate(latest.date)
    : { day: '', month: '', year: '' }

  const handleScrollToEvent = () => {
    const target = document.getElementById('event')
    if (!target) return

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize)
    const offset = 10 * rem

    const elementPosition = target.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.scrollY - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }

  const handleScrollToAbout = () => {
    const target = document.getElementById('about')
    if (!target) return

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize)
    const offset = 10 * rem

    const elementPosition = target.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.scrollY - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }

  return (
    <header className='header-container'>
      <div className='header-container-box'>
        <div className='header-container-title'>Český Šternberk 2026</div>

        <div className='header-container-subtitle header-container-margin'>
          <p>Letní dětský tábor</p>
          <IoCalendar className='header-container-icon' />
          <p>15.8. - 29.8.2026</p>
        </div>

        <div className='header-container-subtitle header-container-subtitle-2'>
          <HiLocationMarker className='header-container-icon header-container-icon-2' />
          <p>Osada Vrábov, 257 26 Český Šternberk</p>
        </div>

        <div className='header-container-subtitle header-container-subtitle-2'>
          <GiMoneyStack className='header-container-icon header-container-icon-2' />
          <p>Cena 6 500 Kč včetně dopravy</p>
        </div>

        <button className='header-container-btn' onClick={handleScrollToEvent}>
          Více informací
        </button>

        <div className='header-container-socials'>
          <a href='https://www.facebook.com/LDTHlavas/' target='blank'>
            <BiLogoFacebook className='header-container-socials-icon' />
          </a>
          <a
            href='https://instagram.com/ldthlavas?igshid=YmMyMTA2M2Y='
            target='blank'
          >
            <BiLogoInstagramAlt className='header-container-socials-icon' />
          </a>
          <a href='mailto:hlavas@hotmail.com'>
            <BiMailSend className='header-container-socials-icon' />
          </a>
          <a href='tel:420739001411'>
            <BiSolidPhoneCall className='header-container-socials-icon' />
          </a>
        </div>

        <Link to='/aktuality'>
          {latest && (
            <div className='news-box'>
              <div className='news-box__date'>
                {day}.{month}.<span>{year}</span>
              </div>
              <div className='news-box__message'>{latest.title}</div>
            </div>
          )}
        </Link>

        <div className='header-container-arrow' onClick={handleScrollToAbout}>
          <FaAnglesDown className='header-container-arrow-icon' />
        </div>
      </div>
    </header>
  )
}

export default Header
